<template>
    <div class="assets-overview-card">
        <!-- 上部：总资产信息 -->
        <div class="overview-top">
            <div class="total-section">
                <div class="total-icon">
                    <img :src="require('@/assets/img/wallet-icon.png')" alt="" />
                </div>
                <div class="total-info">
                    <div class="total-label">
                        总资产(元)
                        <img
                            :src="
                                require(`@/assets/img/${
                                    isAmountVisible ? 'eye-open.svg' : 'eye-close.svg'
                                }`)
                            "
                            alt=""
                            class="eye-icon"
                            v-on:click="toggleAmountVisible"
                        />
                    </div>
                    <div class="total-amount" :class="getAmountClass()">
                        {{ formatAmount(amountType.totalAsset) }}
                    </div>
                    <div v-if="!hideAssetProfit" class="profit-list">
                        <span class="profit-item">
                            今日收益
                            <span class="ml-4" :class="getProfitClass(amountType.lastprofit)">
                                {{ formatProfit(amountType.lastprofit) }}
                            </span>
                        </span>
                        <span v-if="showCurrentProfit" class="profit-item">
                            持仓收益
                            <span class="ml-4" :class="getProfitClass(amountType.currentprofit)">
                                {{ formatProfit(amountType.currentprofit) }}
                            </span>
                        </span>
                        <span class="profit-item">
                            累计收益
                            <span class="ml-4" :class="getProfitClass(amountType.totalProfit)">
                                {{ formatProfit(amountType.totalProfit) }}
                            </span>
                        </span>
                    </div>
                </div>
                <el-tooltip
                    v-if="dataPromptShow && !hideAssetProfit"
                    effect="dark"
                    content="当前收益为直销（每日0点更新）与代销（通常上午10点更新）数据的阶段性汇总，最终以双方数据完全同步后为准。"
                    placement="top-start"
                >
                    <i class="el-icon-question prompt-icon"></i>
                </el-tooltip>
            </div>
        </div>
        <!-- 下部：资产分布 -->
        <div v-if="!$util.isWebQueryMode()" class="overview-bottom">
            <div class="asset-distribution">
                <!-- 基金资产 -->
                <div class="asset-item" :style="assetItemStyle">
                    <div class="asset-left">
                        <span class="asset-name">基金资产(元)</span>
                        <span class="asset-amount" :class="getAmountClass()">
                            {{ formatAmount(amountType.generalAsset) }}
                        </span>
                    </div>
                </div>
                <div v-if="showPrivateAsset || showXjbAsset" class="asset-divider-vertical"></div>

                <!-- 专户资产 -->
                <div
                    v-if="showPrivateAsset"
                    class="asset-item"
                    :style="assetItemStyle"
                    v-on:click="goToPrivatePage"
                >
                    <div class="asset-left">
                        <div class="asset-header">
                            <span class="asset-name">专户资产(元)</span>
                            <i class="el-icon-arrow-right asset-arrow-inline"></i>
                        </div>
                        <span class="asset-amount" :class="getAmountClass()">
                            {{ formatAmount(privateAssetsAmount) }}
                        </span>
                    </div>
                </div>
                <div v-if="showPrivateAsset && showXjbAsset" class="asset-divider-vertical"></div>

                <!-- 现金宝资产 -->
                <div v-if="showXjbAsset" class="asset-item" :style="assetItemStyle">
                    <div class="asset-left">
                        <div class="asset-header">
                            <span class="asset-name">{{ $const.getXJBParam("name") }}资产(元)</span>
                            <i
                                class="el-icon-arrow-right asset-arrow-inline"
                                v-on:click="goToXjbPage"
                            ></i>
                        </div>
                        <div class="asset-amount-row">
                            <span class="asset-amount" :class="getAmountClass()">
                                {{ formatAmount(amountType.xjbMarketvalue) }}
                            </span>
                            <div class="xjb-actions">
                                <a
                                    class="xjb-link"
                                    :class="{ disabled: $util.isPersonalBuyBusinessDisabled() }"
                                    v-on:click.stop="goToXjbCharge"
                                >
                                    充值
                                </a>
                                <span class="xjb-divider">|</span>
                                <a class="xjb-link" v-on:click.stop="goToXjbRedemption">取现</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <dalogChild width="520px" :dialog-visible.sync="showDialog"></dalogChild>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import dalogChild from "@/components/acctInfo/dalogChild.vue";

export default {
    name: "AssetsOverviewCard",
    components: { dalogChild },
    mixins: [mixin],
    props: {
        // 金额类型
        amountType: {
            type: Object,
            required: true
        },
        // 资产列表
        assets: {
            type: Array,
            default: () => []
        },
        // 现金宝基金信息
        xjbFundInfo: {
            type: Object,
            default: () => ({})
        },
        // 收益字段旁提示
        dataPromptShow: {
            type: Boolean,
            default: false
        },
        // 是否展示小问号
        showprofitexplain: {
            type: Boolean,
            default: true
        },
        hideAssetProfit: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showCurrentProfit: true,
            specialAssetAmount: "",
            showDialog: false
        };
    },
    computed: {
        isAmountVisible() {
            return this.$store.state.user.showAssetsNum;
        },
        // 是否显示专户资产（根据高端理财最终菜单展示状态）
        showPrivateAsset() {
            return this.$store.state.user.specialAssetMenuVisible;
        },
        // 是否显示现金宝资产（根据现金宝菜单权限）
        showXjbAsset() {
            return this.$util.xjbIsOpen();
        },
        // 专户资产金额
        privateAssetsAmount() {
            if (this.specialAssetAmount !== "") {
                return this.specialAssetAmount;
            }
            if (!this.assets || this.assets.length === 0) return 0;
            return this.assets
                .filter((item) => item.fundtype === "4")
                .reduce((sum, item) => sum + (parseFloat(item.marketvalue) || 0), 0);
        },
        // 可见资产类型数量
        visibleAssetCount() {
            let count = 1; // 基金资产始终显示
            if (this.showPrivateAsset) count++;
            if (this.showXjbAsset) count++;
            return count;
        },
        // 资产项宽度样式
        assetItemStyle() {
            if (this.visibleAssetCount === 1) {
                return { flex: "0 0 33.333%", maxWidth: "33.333%" };
            }
            const percent = 100 / this.visibleAssetCount + "%";
            return { flex: "1 1 0", maxWidth: percent };
        }
    },
    watch: {
        showPrivateAsset: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.loadPrivateAssetsAmount();
                } else {
                    this.specialAssetAmount = "";
                }
            }
        }
    },
    created() {
        const assetInfo = this.$cache.getParamValue("asset_info");
        if (assetInfo && !this.$util.isEmpty(assetInfo.showtotalcurrentprofit)) {
            this.showCurrentProfit = assetInfo.showtotalcurrentprofit;
        }
    },
    methods: {
        async loadPrivateAssetsAmount() {
            if (!this.$cache.getBinded() && !this.$cache.getCustnoCrm()) {
                this.specialAssetAmount = 0;
                return;
            }
            try {
                const res = await fundApi.qrySpecialAsset({
                    producttype: "@",
                    keyword: "",
                    pageSize: 1,
                    pageNum: 1,
                    assetshowtype: 0,
                    specialassetflag: "1"
                });
                const first = res.data && res.data.first;
                this.specialAssetAmount =
                    first && first.specialasset !== undefined && first.specialasset !== null
                        ? first.specialasset
                        : 0;
            } catch (error) {
                this.specialAssetAmount = 0;
            }
        },
        // 切换金额显示/隐藏
        toggleAmountVisible() {
            this.$store.commit("updateShowAssetsNum");
        },
        // 获取金额显示的 class
        getAmountClass() {
            return this.isAmountVisible ? "" : "amount-hidden";
        },
        // 格式化金额（隐藏时显示 ****）
        formatAmount(value) {
            return this.isAmountVisible ? this.$util.fmtNum(value) : "****";
        },
        // 获取收益项的 class
        getProfitClass(value) {
            if (!this.isAmountVisible) {
                return "amount-hidden";
            }
            return value > 0 ? "add" : value < 0 ? "reduce" : "";
        },
        // 格式化收益（隐藏时显示 ****，可见时添加 + 号）
        formatProfit(value) {
            if (!this.isAmountVisible) {
                return "****";
            }
            const formatted = this.$util.fmtNum(value);
            return value > 0 ? "+" + formatted : formatted;
        },
        // 跳转到专户理财页面
        goToPrivatePage() {
            this.$router.push({ name: "financialManagement" });
        },
        // 跳转到现金宝页面
        goToXjbPage() {
            this.$router.push({ name: "moneybox" });
        },
        // 跳转到现金宝充值页面
        async goToXjbCharge() {
            if (this.$util.checkPersonalBuyBusinessDisabled("充值")) return;
            // 未认证投资者限制交易弹窗
            const limitFlag = await this.$util.shouldShowCertificateDialog("022");
            if (limitFlag) {
                this.showDialog = true;
                return;
            }
            this.$util.fundRiskCheck(this, this.xjbFundInfo, async (res) => {
                if (res) {
                    // 通过cfgFundrealtimeQueryAll接口判断走哪条逻辑
                    const realtaRes = await fundApi.cfgFundrealtimeQueryAll();
                    if (realtaRes.data && realtaRes.data.length > 0) {
                        // 有数据：走实时TA现金宝充值页
                        this.$router.push({ name: "currencycharge" });
                    } else {
                        // 无数据：跳转普通基金购买页
                        const buyfundInfo = Object.assign({}, this.xjbFundInfo, {
                            way: "20,22",
                            proto: "buy"
                        });
                        this.$util.grantTradeSdxAccessAndStoreFund("buyfund", buyfundInfo);
                        this.$router.push({
                            name: "buyfund",
                            query: { fundcode: this.xjbFundInfo.fundcode }
                        });
                    }
                }
            });
        },
        // 跳转到现金宝取现页面
        async goToXjbRedemption() {
            // 未认证投资者限制交易弹窗
            const limitFlag = await this.$util.shouldShowCertificateDialog("024");
            if (limitFlag) {
                this.showDialog = true;
                return;
            }
            // 赎回/取现不是购买交易，不按 qryCustRiskMatchService 的 allowbuyflag 阻断。
            const realtaRes = await fundApi.cfgFundrealtimeQueryAll();
            if (realtaRes.data && realtaRes.data.length > 0) {
                this.$router.push({ name: "currencyredemption" });
            } else {
                const holdingRes = await fundApi.getHoldingAssets({
                    fundcode: this.xjbFundInfo.fundcode
                });
                const fundArr = (holdingRes.data && holdingRes.data.returnList) || [];
                const sellfundInfo = Object.assign({}, this.xjbFundInfo, {
                    way: "24",
                    fundArr: fundArr
                });
                const _sellfundInfo = this.$util.dataTaacFilter(sellfundInfo) || sellfundInfo;
                sessionStorage.setItem("sellfund", JSON.stringify(_sellfundInfo));
                this.$router.push({
                    name: "sellfund",
                    query: { fundcode: this.xjbFundInfo.fundcode }
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
/* 资产总览卡片 */
.assets-overview-card {
    background: var(--linear-gradient-bg);
    border-radius: 4px;
    border: 1px solid;
    border-image: var(--linear-gradient-border);
    margin-bottom: 16px;
    overflow: hidden;

    /* 隐藏金额时 * 号视觉居中补偿 */
    .amount-hidden {
        display: inline-block;
        position: relative;
        transform: translateY(15%);
    }

    /* 上部：总资产 */
    .overview-top {
        padding: 35px 50px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);

        .total-section {
            display: flex;
            align-items: center;
            position: relative;

            .total-icon {
                width: 72px;
                height: 72px;
                margin-right: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;

                img {
                    width: 72px;
                    height: 72px;
                }
            }

            .total-info {
                flex: 1;
                height: 94px;

                .total-label {
                    font-size: 12px;
                    color: var(--color-text-accent);
                    display: flex;
                    align-items: center;
                    line-height: 1;

                    .eye-icon {
                        width: 18px;
                        height: 18px;
                        margin-left: 8px;
                        cursor: pointer;
                        transition: opacity 0.2s;
                        vertical-align: middle;

                        &:hover {
                            opacity: 0.7;
                        }
                    }
                }

                .total-amount {
                    height: 32px;
                    font-size: 32px;
                    font-weight: 500;
                    color: var(--color-text-primary);
                    margin-top: 10px;
                    margin-bottom: 16px;
                }

                .profit-list {
                    display: flex;
                    gap: 90px;
                    height: 22px;
                    align-items: flex-end;
                    line-height: 22px;

                    .profit-item {
                        font-size: 12px;
                        line-height: 16px;
                        min-width: 200px;
                        flex: 1;
                        color: var(--color-text-accent);

                        .ml-4 {
                            margin-left: 4px;
                        }

                        .add {
                            font-size: 22px;
                            font-weight: 500;
                            color: var(--color-up);
                        }

                        .reduce {
                            font-size: 22px;
                            font-weight: 500;
                            color: var(--color-down);
                        }
                    }
                }
            }

            .prompt-icon {
                position: absolute;
                right: 0;
                top: 0;
                color: var(--color-text-accent);
                cursor: pointer;
            }
        }
    }

    /* 下部：资产分布 */
    .overview-bottom {
        padding: 0 30px;

        .asset-distribution {
            display: flex;
            align-items: center;

            .asset-item {
                display: flex;
                align-items: center;
                justify-content: center;
                transition: opacity 0.2s;
                padding: 30px 0;
                min-width: 200px;

                &:hover {
                    opacity: 0.8;
                }

                .asset-left {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;

                    .asset-header {
                        display: flex;
                        align-items: center;
                        gap: 4px;

                        .asset-arrow-inline {
                            color: var(--color-text-accent);
                            font-size: 14px;
                            cursor: pointer;
                        }
                    }

                    .asset-name {
                        font-size: 12px;
                        color: var(--color-text-accent);
                    }

                    .asset-amount {
                        font-size: 22px;
                        font-weight: 500;
                        min-width: 104px;
                        color: var(--color-text-primary);
                    }

                    .asset-amount-row {
                        display: flex;
                        align-items: center;
                        gap: 12px;

                        .xjb-actions {
                            display: flex;
                            align-items: center;
                            gap: 6px;
                            line-height: 1;

                            .xjb-link {
                                font-size: 14px;
                                color: var(--color-redirect);
                                cursor: pointer;
                                text-decoration: none;
                                line-height: 22px;

                                &.disabled {
                                    color: var(--color-text-weak);
                                    cursor: not-allowed;
                                }
                            }

                            .xjb-divider {
                                color: var(--color-divided);
                                font-size: 14px;
                            }
                        }
                    }
                }
            }

            .asset-divider-vertical {
                width: 1px;
                height: 60px;
                background: rgba(0, 0, 0, 0.08);
                flex-shrink: 0;
            }
        }
    }
}
</style>
